import type {
	SubscribeToNewsletterMutation,
	SubscribeToNewsletterMutationVariables,
} from '../../mutations/__generated__/subscribeToNewsletter.generated';

/**
 * Sends the `subscribeToNewsletter` GraphQL mutation, loading the GraphQL client and the
 * query document on first use.
 *
 * WHY: the newsletter form sits in every page's footer, and importing the
 * client up front put `graphql` and `graphql-request` (~55 KiB raw) in the
 * scripts every page preloads, for a form few visitors submit.
 */
export const subscribeToNewsletter = async (
	variables: SubscribeToNewsletterMutationVariables
): Promise<SubscribeToNewsletterMutation> => {
	const [{ getMutation }, { SubscribeToNewsletterDocument }] =
		await Promise.all([
			import('#lib/query-utils/getMutation.js'),
			import('../../mutations/__generated__/subscribeToNewsletter.generated'),
		]);

	return getMutation(SubscribeToNewsletterDocument).mutationFn(variables);
};
